
<canvas id="canvas" hedera
  (hederaStartup)="onHederaStartup($event)" 
  (hederaUpdate)="onHederaUpdate($event)"
  [cameraFarPlane]="400"
  [cameraType]="'orbit'"
  (wheel)="onWheelMove($event)"
></canvas>

<div class="card m-3" style="z-index: 1000; position: absolute; top: 0; left: 0;">
  <div class="card-body">
    <div class="row">
      <div class="col-12 text-center">
        <button type="button" class="btn mr-3" 
          [ngClass]="mainAnimationRunning ? 'btn-danger' :  'btn-success'" 
          [disabled]="animating"
          (click)="startMainAnimation()">
          {{mainAnimationRunning ? 'Running ...' : 'Full assembly'}} 
        </button>
      
        <button type="button" class="btn btn-primary mr-3" 
          [disabled]="animating"
          (click)="toggleEsploso ? implodiMotore() : esplodiMotore(); toggleEsploso = !toggleEsploso">
          {{toggleEsploso ? 'Reset' : 'Explode'}} 
        </button>
      
        <button type="button" class="btn btn-warning" 
          [disabled]="animating"
          (click)="!stepAnimationRunning ? nextStep() : exitStepMode()">
          {{stepAnimationRunning ? 'Exit' : 'Steps'}} 
        </button>
      </div>
    </div>
  </div>
  
</div>

<div class="card m-3" style="z-index: 1000; position: absolute; bottom: 0; left: 0" *ngIf="stepAnimationRunning">
  <div class="card-body">
    <div class="row">
      <div class="col-12 text-center">
        <button type="button" class="btn btn-primary mr-3" (click)="prevStep()" [disabled]="stepAnimationRunning < 2 || animating">
          <fa-icon [icon]="faArrowLeft"></fa-icon>
        </button>
        <button type="button" class="btn btn-primary" (click)="nextStep()" [disabled]="stepAnimationRunning >= maxStep || animating">
          <fa-icon [icon]="faArrowRight"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card m-3" style="z-index: 1000; position: absolute; bottom: 0; right: 0" >
  <div class="card-body">
    <div class="row">
      <div class="col-12 text-center">
        <button type="button" class="btn btn-secondary mr-3" (click)="onZoomClickMinus()">
          <fa-icon [icon]="faSearchMinus"></fa-icon>
        </button>
        <button type="button" class="btn btn-secondary" (click)="onZoomClickPlus()">
          <fa-icon [icon]="faSearchPlus"></fa-icon>
        </button>
      </div>
    </div>
  </div>
</div>


<!--
<div class="card m-3" style="z-index: 1000; position: absolute; bottom: 0; left: 0" [style.opacity]="animating ? '0.5' : '1'">
  <div class="card-body">

    <div class="row">
      <div class="col-4 text-center">
        <button type="button" class="btn w-100 mx-auto btn-dark"
          [disabled]="animating" 
          (click)="startStep1Animation()"> 
          {{step1AnimationRunning ? 'Valves (Running ...)' : 'Valves'}} 
        </button>
      </div>
      <div class="col-4 text-center">
        <button type="button" class="btn w-100 mx-auto btn-dark"
          [disabled]="animating" 
          (click)="startStep2Animation()"> 
          {{step2AnimationRunning ? 'Crankshaft (Running ...)' : 'Crankshaft'}} 
        </button>
      </div>
      <div class="col-4 text-center">
        <button type="button" class="btn w-100 mx-auto btn-dark"
          [disabled]="animating" 
          (click)="startStep3Animation()"> 
          {{step3AnimationRunning ? 'Flywheel (Running ...)' : 'Flywheel'}} 
        </button>
        
      </div>
    </div>
    
  </div>
</div>
-->
<div class="w-100 h-100 d-flex justify-content-between position-absolute" style="top: 0" *ngIf="loading">
  <img src="assets/spinner.svg" class="m-auto">
</div>
